import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as Actions from "./actions";
import * as Api from "./api";
import history from "../../utils/history";
import { IS_DEV } from "@app/constants";

function* codeLoginRequestHandler(action) {
  try {
    localStorage.removeItem("access_token");
    localStorage.removeItem("totp_token");
    localStorage.removeItem("class_login_token");
    const { response } = yield call(Api.codeLogin, action.payload.code, action.payload.email);
    yield put(Actions.codeLogin.success(response));
    !response.is_email_required && localStorage.setItem("code_login_token", response.code);
    localStorage.removeItem("refresh_token");

    if (response.is_otp_required && !response.is_email_required) yield call(Api.generateStudentChallenge);
    if (!response.is_email_required && !response.is_otp_required) {
      localStorage.setItem("student_verified", true);
      yield put(Actions.loadUser.request());
    }
  } catch (error) {
    yield put(Actions.codeLogin.failure(error));
  }
}

function* loginValueRequestHandler(action) {
  try {
    localStorage.removeItem("access_token");
    localStorage.removeItem("totp_token");
    localStorage.removeItem("code_login_token");
    const { response } = yield call(Api.loginValue, action.payload.code, action.payload.fullName);
    localStorage.setItem("class_login_token", response.code);
    yield put(Actions.loginValue.success(response));
    yield put(Actions.loadUser.request());
  } catch (error) {
    yield put(Actions.loginValue.failure(error));
  }
}

function* loginRequestHandler(action) {
  try {
    localStorage.removeItem("code_login_token");
    localStorage.removeItem("class_login_token");
    const { response } = yield call(Api.login, action.payload.username, action.payload.password);
    localStorage.setItem("access_token", response.access);
    localStorage.setItem("refresh_token", response.refresh);
    yield put(Actions.login.success(response));
    yield call(Api.generateChallenge);
  } catch (error) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("totp_token");
    yield put(Actions.login.failure(error));
  }
}

function* otpLoginRequestHandler(action) {
  try {
    const { response } = yield call(Api.loginOTP, action.payload.code);
    localStorage.setItem("refresh_token", JSON.parse(response).refresh);
    localStorage.setItem("totp_token", JSON.parse(response).access);
    localStorage.setItem("access_token", JSON.parse(response).access);
    yield put(Actions.otpLogin.success());
    yield put(Actions.loadUser.request());
    //yield put(ClinicsActions.loadClinics.request());
    yield call([history, history.push], "/home/");
  } catch (error) {
    yield put(Actions.otpLogin.failure(error));
  }
}

function* loginStudentOTPRequestHandler(action) {
  try {
    const { response } = yield call(Api.loginStudentOTP, action.payload.code);
    localStorage.setItem("code_login_token", response[0]);

    yield put(Actions.studentLoginOTP.success());
    yield put(Actions.loadUser.request());
    yield call([history, history.push], "/home/");
  } catch (error) {
    yield put(Actions.otpLogin.failure(error));
  }
}

function* loadCurrentUserRequestHandler() {
  try {
    const { response } = yield call(Api.loadCurrentUser);
    yield put(Actions.loadUser.success(response));
  } catch (error) {
    yield put(Actions.loadUser.failure(error));
  }
}

function* socialLoginRequestHandler(action) {
  try {
    const { response } = yield call(Api.socialLogin, action.payload.provider);
    yield put(Actions.socialLogin.success(response));
  } catch (error) {
    yield put(Actions.socialLogin.failure(error));
  }
}

function castProviderRes(response) {
  return {
    ...response,
    role: parseInt(response.role),
    studio_role: parseInt(response.studio_role),
    id: parseInt(response.id),
  };
}

function* providerLoginRequestHandler(action) {
  try {
    localStorage.removeItem("code_login_token");
    localStorage.removeItem("class_login_token");
    const { response } = yield call(Api.providerLogin, action.payload.provider, action.payload.state, action.payload.code);
    const castRes = castProviderRes(response);
    localStorage.setItem("access_token", JSON.parse(castRes.token).access);
    localStorage.setItem("totp_token", JSON.parse(castRes.token).access);
    localStorage.setItem("refresh_token", JSON.parse(castRes.token).refresh);
    yield put(Actions.providerLogin.success({ ...castRes, provider: action.payload.provider }));
    yield put(Actions.loadUser.request());
  } catch (error) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("totp_token");
    yield put(Actions.providerLogin.failure({ error, provider: action.payload.provider }));
  }
}

function logoutRequestHandler() {
  try {
    localStorage.clear();
    Api.logout();
  } catch (e) {
    console.error(e);
  }
  localStorage.removeItem("code_login_token");
  localStorage.removeItem("class_login_token");
  localStorage.removeItem("access_token");
  localStorage.removeItem("totp_token");
  localStorage.removeItem("_okdetect");
  localStorage.removeItem("debug");
  sessionStorage.removeItem("welcome_page_saw");
  localStorage.removeItem("SessionTimeout");
  window.location = "/login/";
  if (IS_DEV) {
    document.title = "Amplio";
  }
}

function* passwordRequestHandler(action) {
  try {
    const { response } = yield call(Api.password, action.payload.email);
    yield put(Actions.password.success(response));
    //yield call([history, history.push], "/login");
  } catch (error) {
    yield put(Actions.password.failure(error));
    //yield put(addMessageNotificationCenter(error.email[0], "error"));
  }
}

function* passwordResetRequestHandler(action) {
  try {
    const { response } = yield call(
      Api.passwordReset,
      action.payload.new_pwd,
      action.payload.re_new_pwd,
      action.payload.uuid,
      action.payload.token,
    );
    yield put(Actions.passwordReset.success(response));
    yield call([history, history.push], "/login");
  } catch (error) {
    yield put(Actions.passwordReset.failure(error));
  }
}

function* verifyVersionRequestHandler(action) {
  try {
    const { response } = yield call(Api.verifyVersion, action.payload.ui_version);
    yield put(Actions.verifyVersion.success(response));
  } catch (error) {
    if (error.name === "400" && error.ui_version && error.app_url) {
      window.location.href = error.app_url;
      localStorage.setItem("ui_version", error.ui_version);
    }
    yield put(Actions.verifyVersion.failure(error));
  }
}

function* watchCodeLoginRequest() {
  yield takeLatest(Actions.CODE_LOGIN.REQUEST, codeLoginRequestHandler);
}

function* watchLoginRequest() {
  yield takeLatest(Actions.LOGIN.REQUEST, loginRequestHandler);
}

function* watchLoginValueRequest() {
  yield takeLatest(Actions.LOGIN_VALUE.REQUEST, loginValueRequestHandler);
}

function* watchSocialLoginRequest() {
  yield takeLatest(Actions.SOCIAL_LOGIN.REQUEST, socialLoginRequestHandler);
}

function* watchProviderLoginRequest() {
  yield takeLatest(Actions.PROVIDER_LOGIN.REQUEST, providerLoginRequestHandler);
}

function* watchLoginOTPRequest() {
  yield takeLatest(Actions.LOGIN_OTP.REQUEST, otpLoginRequestHandler);
}

function* watchLoginStudentOTPRequest() {
  yield takeLatest(Actions.LOGIN_STUDENT_OTP.REQUEST, loginStudentOTPRequestHandler);
}

function* watchLoadCurrentUserRequest() {
  yield takeLatest(Actions.USER.REQUEST, loadCurrentUserRequestHandler);
}

function* watchLogoutRequest() {
  yield takeLatest(Actions.LOGOUT.REQUEST, logoutRequestHandler);
}

function* watchPasswordRequest() {
  yield takeLatest(Actions.PASSWORD.REQUEST, passwordRequestHandler);
}

function* watchPasswordResetRequest() {
  yield takeLatest(Actions.PASSWORD_RESET.REQUEST, passwordResetRequestHandler);
}

function* watchVerifyVersionRequest() {
  yield takeLatest(Actions.VERIFY_VERSION.REQUEST, verifyVersionRequestHandler);
}

export default function* authSagas() {
  yield all([
    fork(watchCodeLoginRequest),
    fork(watchLoginRequest),
    fork(watchLoginValueRequest),
    fork(watchSocialLoginRequest),
    fork(watchProviderLoginRequest),
    fork(watchLoginOTPRequest),
    fork(watchLoginStudentOTPRequest),
    fork(watchLoadCurrentUserRequest),
    fork(watchLogoutRequest),
    fork(watchPasswordRequest),
    fork(watchPasswordResetRequest),
    fork(watchVerifyVersionRequest),
  ]);
}
